module.exports = __webpack_public_path__ + "assets/img/detail14.19baf12d.png";